import {cva} from 'class-variance-authority'

/**
 * Sidebar (v3): the persistent left-nav rail shell. Mirrors `TopNav`'s `color`
 * vocabulary so an app bar and rail can be themed as one surface.
 * - `light` — white app surface, dark rows (the default).
 * - `dark` — deep-teal `primary-contrast` (#004E56) brand rail, white rows.
 */
export const SidebarVariantsFactory = cva('flex flex-col', {
  variants: {
    color: {
      light: 'bg-background',
      dark: 'bg-primary-contrast',
    },
    collapsed: {
      // The mini rail is narrow — tighter gutters keep the icons centered.
      true: 'px-2',
      false: 'px-4',
    },
  },
  defaultVariants: {
    color: 'light',
    collapsed: false,
  },
})
